/**
 * @generated SignedSource<<ee9450f5c00d08f5a902f10fc93143b2>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespHeroCarousel_item$data = {
  readonly firstPhotoWebPath: string | null;
  readonly hasPrivateListing: boolean | null;
  readonly seller: {
    readonly isAccessible: boolean | null;
  } | null;
  readonly serviceId: string | null;
  readonly sortedPhotos: ReadonlyArray<{
    readonly __typename: "ItemPhoto";
    readonly alt: string | null;
    readonly largePath: string | null;
    readonly masterOrZoomPath: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"HeroCarouselImage_sortedPhoto" | "HeroCarouselThumb_sortedPhoto" | "useItemMediaItems_sortedPhotos">;
  } | null> | null;
  readonly title: string | null;
  readonly videoMux: {
    readonly assetId: string | null;
    readonly height: number | null;
    readonly thumbnail: string | null;
    readonly url: string | null;
    readonly width: number | null;
    readonly " $fragmentSpreads": FragmentRefs<"HeroCarouselThumb_muxVideo" | "useItemMediaItems_muxVideo">;
  } | null;
  readonly videoVimeo: {
    readonly height: number | null;
    readonly thumbnail: string | null;
    readonly videoUrl: {
      readonly link: string | null;
    } | null;
    readonly vimeoId: string | null;
    readonly width: number | null;
    readonly " $fragmentSpreads": FragmentRefs<"HeroCarouselThumb_videoVimeo" | "VideoContainer_videoVimeo" | "useItemMediaItems_videoVimeo">;
  } | null;
  readonly viewInRoomPhotos: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"HeroCarouselThumb_viewInRoomPhoto" | "ViewInRoom_viewInRoomPhoto" | "useItemMediaItems_viewInRoomPhotos">;
  } | null> | null;
  readonly " $fragmentSpreads": FragmentRefs<"HeroCarouselImage_item" | "HeroCarouselRequestMore_item" | "ViewInRoom_item" | "useItemMediaItems_item">;
  readonly " $fragmentType": "PdpRespHeroCarousel_item";
};
export type PdpRespHeroCarousel_item$key = {
  readonly " $data"?: PdpRespHeroCarousel_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespHeroCarousel_item">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "width",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "height",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespHeroCarousel_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useItemMediaItems_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HeroCarouselImage_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ViewInRoom_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HeroCarouselRequestMore_item"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemPhoto",
      "kind": "LinkedField",
      "name": "sortedPhotos",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "useItemMediaItems_sortedPhotos"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "HeroCarouselThumb_sortedPhoto"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "HeroCarouselImage_sortedPhoto"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "masterOrZoomPath",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "largePath",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "alt",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "VideoVimeo",
      "kind": "LinkedField",
      "name": "videoVimeo",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "useItemMediaItems_videoVimeo"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "HeroCarouselThumb_videoVimeo"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "VideoContainer_videoVimeo"
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "includePlayButton",
              "value": false
            },
            {
              "kind": "Literal",
              "name": "pad",
              "value": false
            },
            {
              "kind": "Literal",
              "name": "size",
              "value": "w100h75"
            }
          ],
          "kind": "ScalarField",
          "name": "thumbnail",
          "storageKey": "thumbnail(includePlayButton:false,pad:false,size:\"w100h75\")"
        },
        (v0/*:: as any*/),
        (v1/*:: as any*/),
        {
          "alias": "videoUrl",
          "args": [
            {
              "kind": "Literal",
              "name": "size",
              "value": "adaptive"
            }
          ],
          "concreteType": "VideoVimeoFile",
          "kind": "LinkedField",
          "name": "fileByVideoSize",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "link",
              "storageKey": null
            }
          ],
          "storageKey": "fileByVideoSize(size:\"adaptive\")"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "vimeoId",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "VideoV2",
      "kind": "LinkedField",
      "name": "videoMux",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "useItemMediaItems_muxVideo"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "HeroCarouselThumb_muxVideo"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "assetId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "height",
              "value": 75
            },
            {
              "kind": "Literal",
              "name": "width",
              "value": 100
            }
          ],
          "kind": "ScalarField",
          "name": "thumbnail",
          "storageKey": "thumbnail(height:75,width:100)"
        },
        (v0/*:: as any*/),
        (v1/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "viewInRoomPhotos",
      "kind": "LinkedField",
      "name": "viewInRoomPhotos",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "useItemMediaItems_viewInRoomPhotos"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "HeroCarouselThumb_viewInRoomPhoto"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ViewInRoom_viewInRoomPhoto"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasPrivateListing",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Seller",
      "kind": "LinkedField",
      "name": "seller",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isAccessible",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "size",
          "value": "small"
        }
      ],
      "kind": "ScalarField",
      "name": "firstPhotoWebPath",
      "storageKey": "firstPhotoWebPath(size:\"small\")"
    }
  ],
  "type": "Item",
  "abstractKey": null
};
})();

(node as any).hash = "81e9a879b4842b87b704f7dc20e3efdf";

export default node;
